import { AddIcon, MinusIcon } from "@chakra-ui/icons";
import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  Box,
  useTheme,
} from "@chakra-ui/react";
import React from "react";

export type AccordionFormFieldProps = {
  options: any[];
  isValid: (itemInLoop: any) => boolean;
  heading: (isExpanded: boolean, itemInLoop: any) => React.ReactNode;
  renderFormField: (itemInLoop: any) => React.ReactNode;
  onAccordionClose?: (itemInLoop: any) => void;
};
export const AccordionFormField: React.FC<AccordionFormFieldProps> = ({
  isValid,
  options,
  heading,
  renderFormField,
  onAccordionClose,
  ...rest
}) => {
  const { colors } = useTheme();
  return (
    <Accordion allowToggle border={0} {...rest}>
      {options.map((item, idx) => {
        return (
          <AccordionItem mb={2} key={idx} border={0}>
            {({ isExpanded }) => (
              <React.Fragment>
                <AccordionButton
                  px={[4, 5]}
                  py={4}
                  bg={isExpanded ? "gray.100" : "inherit"}
                  alignItems="center"
                  borderWidth="2xs"
                  borderRadius={isExpanded ? "8px 8px 0 0" : "8px"}
                  opacity={0.8}
                  _hover={{ bg: isExpanded ? "gray.200" : "gray.50" }}
                  _focus={{ outline: "none" }}
                  border={
                    !isExpanded && isValid(item)
                      ? "1px solid lighblue"
                      : "1px solid lightgrey"
                  }
                  onClick={() => {
                    if (isExpanded && onAccordionClose) {
                      onAccordionClose(item);
                    }
                  }}
                  boxShadow={
                    !isExpanded && isValid(item)
                      ? `0 0 0 1px ${colors.blue[400]}`
                      : "none"
                  }
                >
                  <Box flex="1" textAlign="left" mr={[3, 5]}>
                    {heading(isExpanded, item)}
                  </Box>

                  {isExpanded ? (
                    <MinusIcon fontSize="12px" />
                  ) : (
                    <AddIcon fontSize="12px" />
                  )}
                </AccordionButton>
                <AccordionPanel
                  p={6}
                  borderWidth="2xs"
                  borderRadius="0 0 8px 8px"
                  borderTopWidth="none"
                  borderColor="neutral.500"
                >
                  {renderFormField(item)}
                </AccordionPanel>
              </React.Fragment>
            )}
          </AccordionItem>
        );
      })}
    </Accordion>
  );
};
